<template lang="pug">
  .wrap
    page-title Edit Program

    program-form(v-if='entity' v-model='entity' @save='onSave' @delete='confirmDelete')

</template>

<script>
import PageTitle from "@/shared/components/layout/PageTitle";
import ProgramForm from "@/itrain/components/shared/programs/ProgramForm";
import CrudMixin from "@/shared/mixins/Crud";

export default {
  components: { PageTitle, ProgramForm },
  mixins: [CrudMixin],
  data() {
    return {
      entity: null
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    entityId() {
      return this.$route.params.programId;
    }
  },
  methods: {
    loadData() {
      this.wrapLoadAction(data =>
        this.$store.dispatch("programs/fetchDetail", data)
      )({
        id: this.entityId
      }).then(data => {
        this.entity = data;
      });
    },
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const dataToSave = {
        ...this.entity,
        assigneeUserIds: this.entity.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.entity.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };

      this.wrapApiAction(data => this.$store.dispatch("programs/update", data))(
        { data: dataToSave }
      ).then(data => {
        this.entity = data;
      });
    },
    async confirmDelete() {
      await this.$confirm(
        "This will permanently delete this course. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      );

      await this.wrapApiAction(data =>
        this.$store.dispatch("programs/delete", data)
      )({ id: this.entity.id });

      this.$message({
        type: "info",
        message: "Course deleted"
      });

      this.$router.push({ name: "itrain:programList" });
    }
  }
};
</script>

<style scoped lang="scss"></style>
